const initialState = {
    getEmployListDetails: null,
    getEmployListStatus: false,
    addEmployStatus:false,
    editEmployeStatus:false,
    deleteEmployeStatus:false,
    getPaymentRulesDetails:null,
    getPaymentRulesStatus:false,
    editPaymentRuleStatus :false,
    savePaymentRule: null,
    message: null,
    getApproximateCostDetails: null,
    getApproximateCostStatus: false,
    updateApproximateCostDetails: null,
    updateApproximateCostStatus: false,
    getBestPerformanceDetails:null,
    getBestPerformanceStatus:false,
    getRequestStatusListDetails:null,
    getRequestStatusListStatus:false,
    getRevenueReportStatus:false,
    getRevenueReportList:null,
    getFaxedReportStatus:false,
    getFaxedReportList:null,
    getAverageReportStatus:false,
    getAverageReportList:null,
  
    getFacilityReportStatus:false,
    getFacilityReportList:null,
    getPractitionerReportStatus:false,
    getPractitionerReportList:null,

    getHedisFlatDetails: null,
    getHedisFlatStatus: false,
    updateHedisFlatDetails: null,
    updateHedisFlatStatus: false,
    deleteUnprocessedRequestStatus:false,
    getMonthlyRequestListDetails:null,
    getMonthlyRequestStatus:false,

    deleteRequestedPracticeStatus:false,
   };
  export default initialState;